import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ComponentAccess } from '../../common/decorators/component-access.decorator';
import { AppFooterComponent } from './app.footer.component';
import { AppTopProgressComponent } from './app.top-progress.component';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, AppFooterComponent, AppTopProgressComponent],
  template: `
    <app-top-progress></app-top-progress>
    <div class="layout-wrapper" [ngClass]="containerClass()">
      <div class="layout-main-container">
        <div class="layout-main">
          <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
      </div>
      <div class="layout-mask"></div>
    </div>
  `,
})
@ComponentAccess('PublicLayoutComponent')
export class PublicLayoutComponent {
  layoutService = inject(LayoutService);

  containerClass = computed(() => {
    const mode = this.layoutService.effectiveMenuMode();
    return {
      'layout-overlay': mode === 'overlay',
      'layout-static': mode === 'static',
      'layout-static-inactive':
        this.layoutService.state.staticMenuDesktopInactive() &&
        mode === 'static',
      'layout-overlay-active': this.layoutService.state.overlayMenuActive(),
      'layout-mobile-active':
        this.layoutService.state.staticMenuMobileActive(),
    };
  });
}
